import {
  RiskPoint,
  RiskPointApiResponse,
  RiskTimeline,
  RiskTimelineApiResponse,
} from '@/apis/risks/types/risksApi';

function toRiskPoint(p: RiskPointApiResponse): RiskPoint {
  return {
    date: p.Date,
    riskScore: p.RiskScore ? +(p.RiskScore * 100).toFixed(2) : 0,
    totalHours: p.TotalHours,
    injury: undefined,
  };
}

function upsertInjuryDate(
  points: RiskPoint[],
  injuryDate: string,
): RiskPoint[] {
  const d = new Date(injuryDate);

  const existingIndex = points.findIndex((p) => p.date === injuryDate);

  if (existingIndex !== -1) {
    return points.map((p, i) =>
      i === existingIndex ? { ...p, injury: p.riskScore } : p,
    );
  }

  const insertIndex = points.findIndex((p) => new Date(p.date) > d);

  if (insertIndex === -1) {
    const last = points[points.length - 1];
    return [
      ...points,
      {
        date: injuryDate,
        riskScore: undefined,
        injury: last.riskScore,
        totalHours: 0,
      },
    ];
  }

  const prev = points[insertIndex - 1];
  return [
    ...points.slice(0, insertIndex),
    {
      date: injuryDate,
      riskScore: undefined,
      injury: prev.riskScore,
      totalHours: 0,
    },
    ...points.slice(insertIndex),
  ];
}

export const risksTimelineFromApiAdapter = (
  api: RiskTimelineApiResponse,
): RiskTimeline => {
  let points = api.Points.map(toRiskPoint);

  points = [...points].sort(
    (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime(),
  );

  for (const injury of api.Injuries) {
    points = upsertInjuryDate(points, injury.DateInjury);
  }

  return {
    empId: api.EmpID,
    outageId: api.OutageID,
    points,
  };
};
